import { ApolloError } from "@apollo/client";

export const DIRECTORY_CONVERSATION_RATE_LIMIT_MESSAGE =
  "Hey, you've sent too many connection requests recently. Please wait and try again later.";

const DIRECTORY_CONVERSATION_FALLBACK_ERROR_MESSAGE =
  "We couldn't create the Slack conversation.";

export const getDirectoryConversationErrorMessage = (
  error: unknown
): string => {
  const apolloError = error as Partial<ApolloError> | null | undefined;
  const isRateLimited =
    apolloError?.graphQLErrors?.some(
      ({ extensions }) => extensions?.code === "TOO_MANY_REQUESTS"
    ) ||
    (apolloError?.networkError as { statusCode?: number } | null | undefined)
      ?.statusCode === 429;

  if (isRateLimited) {
    return DIRECTORY_CONVERSATION_RATE_LIMIT_MESSAGE;
  }

  return error instanceof Error
    ? error.message
    : DIRECTORY_CONVERSATION_FALLBACK_ERROR_MESSAGE;
};
